const vhResize = {
	resizeTimer: null
};

function vh() {
	const vh = window.innerHeight * 0.01
	document.documentElement.style.setProperty('--vh', `${vh}px`)
}

window.addEventListener('resize', function () {
	clearTimeout(vhResize.resizeTimer);
	vhResize.resizeTimer = setTimeout(vh, 250);
});

document.addEventListener('DOMContentLoaded', function () {
	const mobileMenuWrapper = document.querySelector('.js-mobile-menu');
	const burgerBtn = document.querySelector('.js-menu-btn');
	const burgerClose = document.querySelector('.js-menu-close-btn');
	const siteWrap = document.querySelector('body');

	vh()

	if (burgerClose) {
		burgerClose.addEventListener('click', function () {
			toggleMenu();
		});
	}

	if (burgerBtn) {
		burgerBtn.addEventListener('click', function () {
			toggleMenu();
		});
	}

	function toggleMenu() {
		mobileMenuWrapper.classList.toggle('mobile-menu-wrap--open');
		siteWrap.classList.toggle('no-scroll');
		siteWrap.parentElement.classList.toggle('no-scroll');
		siteWrap.classList.toggle('mobile-menu-is-open');
	}
});


$('.js-reviews-slick').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	speed: 700,
	dots: true,
	arrows: true
});


$('.c-slider-1').slick({
	dots: false,
	speed: 600,
	infinite: false,
	arrows: true,
	slidesToShow: 5,
	centerPadding: '0px',
	autoplay: false,
	autoplaySpeed: 2000,
	slidesToScroll: 1,
	vertical: true,
	prevArrow: '<button type="button" class="slick-prev">Previous</button>',
	nextArrow: '<button type="button" class="slick-next">Next</button>',
	responsive: [{
		breakpoint: 1370,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: false,
			dots: false
		}
	}, {
		breakpoint: 1230,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: false,
			dots: false
		}
	}, {
		breakpoint: 1024,
		settings: {
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: false,
			dots: false
		}
	},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});

$('.after-before-sliderf').slick({
	dots: true,
	infinite: true,
	speed: 600,
	arrows: true,
	slidesToShow: 4,
	centerPadding: '0px',
	autoplay: true,
	autoplaySpeed: 2000,
	slidesToScroll: 1,
	prevArrow: '<button type="button" class="slick-prev">Previous</button>',
	nextArrow: '<button type="button" class="slick-next">Next</button>',
	responsive: [{
		breakpoint: 1370,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: true
		}
	}, {
		breakpoint: 1230,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: true
		}
	}, {
		breakpoint: 1024,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			dots: true
		}
	},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});

$('.mainfaq_q h2').click(function () {
	$(this).next('p').slideToggle(500);
	$(this).parent('div').toggleClass('active');
	$(this).parent('div').siblings().removeClass('active').children('p').slideUp(500);
});

$('.new-featured .slider').slick({
	slidesToShow: 4,
	slidesToScroll: 4,
	speed: 300,
	dots: true,
	arrows: true,
	infinite: false,
	responsive: [
		{
			breakpoint: 1201,
			settings: {
				slidesToScroll: 3,
				slidesToShow: 3
			}
		},
		{
			breakpoint: 992,
			settings: {
				arrows: false,
				dots: true,
				slidesToShow: 3,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToScroll: 2,
				slidesToShow: 2,
				dots: true,
			}
		},
		{
			breakpoint: 568,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 1.5,
				dots: true,
			}
		},
		{
			breakpoint: 500,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 1.5,
				dots: true,
			}
		}
	]
})

$('.new-video .holder').on('click', function () {
	$(this).addClass('hidden')
	$(this).parents('.new-video').find('video')[0].play()
	return false
})

seen_options = {
	slidesToShow: 3,
	slidesToScroll: 1,
	speed: 300,
	dots: false,
	arrows: true,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1
			}
		}
	]
}

if ($('.new-seen .slider').length) {
	$('.new-seen .slider').each(function () {
		var opt = seen_options
		opt.slidesToShow = $(this).attr('data-limit')
		$(this).slick(seen_options)
	})

	var mySlider = $('.new-seen .slider').on('init', function (slick) {
		multiSlideAdaptiveHeight(this);
	}).on('beforeChange', function (slick, currentSlide, nextSlide) {
		multiSlideAdaptiveHeight(this);
	}).slick(seen_options);
}


function multiSlideAdaptiveHeight(slider) {

	activeSlides = [];
	tallestSlide = 0;

	setTimeout(function () {
		$('.slick-track .slick-active', slider).each(function (item) {
			activeSlides[item] = $(this).outerHeight();
		});
		activeSlides.forEach(function (item) {
			if (item > tallestSlide) {
				tallestSlide = item;
			}
		});
		// $('.slick-list', slider).height(tallestSlide);
	}, 10);

}

$(window).on('resize', function () {
	multiSlideAdaptiveHeight(mySlider);
});


document.addEventListener('rebuy:cart.change', function (event) {
	console.log('rebuy:cart.change event', event.detail);
});

$('.acc-q').on('click', function () {
	bid = $(this).parent().attr('data-id')
	$(this).parent().toggleClass('active')
	$(this).next().slideToggle(500)

	$('.acc-q').each(function () {
		if ($(this).parent().attr('data-id') != bid) {
			$(this).parent().removeClass('active')
			$(this).next().slideUp(500)
		}
	})
})

$('.new-q .buttons a').on('click', function () {
	var input = $(this).parents('.new-q').find('input'), q = parseInt(input.val())
	if ($(this).is('.plus')) {
		input.val(q + 1)
	} else {
		if (q > 1) {
			input.val(q - 1)
		}
	}
	return false
})

$('.rc_heading a').on('click', function () {
	$('.subinfo').addClass('active')
	return false
})

$('.subinfo').on('click', '.bg, .close', function () {
	$('.subinfo').removeClass('active')
	return false
})

// SEO FAQ JS FOR DETAILS/SUMMARY START

// Fetch all the details element.
const details = document.querySelectorAll("details");

// Add the onclick listeners.
details.forEach((targetDetail) => {
	targetDetail.addEventListener("click", () => {
		// Close all the details that are not targetDetail.
		details.forEach((detail) => {
			if (detail !== targetDetail) {
				detail.removeAttribute("open");
			}
		});
	});
});

// SEO FAQ JS FOR DETAILS/SUMMARY END


window.addEventListener('DOMContentLoaded', () => {
	const links = document.querySelectorAll('.main-menu > li > a');
	links.forEach(link => {
		const linkHref = link.getAttribute('href');
		if (linkHref.includes('/collections/') && window.location.pathname.includes('/collections/')) {
			link.classList.add('active');
		}
	});


	function waitForElement(selector) {
		return new Promise((resolve, reject) => {
			const el = document.querySelector(selector);
			if (el) {
				resolve(el);
			} else {
				new MutationObserver((mutationRecords, observer) => {
					const el = document.querySelector(selector);
					if (el) {
						observer.disconnect();
						resolve(el);
					}
				})
					.observe(document.documentElement, {
						childList: true,
						subtree: true
					});
			}
		});
	}

	function modifyReviewListItems(element) {
		const reviewsNewCustomerContainers = element.querySelectorAll('.junip-customer-details');
		const reviewsNewCustomerStarsContainers = element.querySelectorAll('.junip-review-list-item .junip-flex-wrapper .junip-star-ratings-container');
		const reviewsNewCustomerStarsTitleContainers = element.querySelectorAll('.junip-review-list-item .junip-flex-wrapper');
		const reviewsNewCustomerTitles = element.querySelectorAll('.junip-review-list-item .junip-review-title');

		reviewsNewCustomerStarsTitleContainers.forEach((container, index) => {
			container.prepend(reviewsNewCustomerTitles[index]);
		});
		reviewsNewCustomerContainers.forEach((container, index) => {
			container.append(reviewsNewCustomerStarsContainers[index]);
		});
	}

	// waitForElement('.junip-product-review.junip-product-review-rendered')
	// 	.then(element => {
	// 		const reviewsTitle = element.querySelector('.junip-product-review-title');
	// 		const reviewsNewContainer = element.querySelector('.junip-product-review-summary-wrapper div');
	// 		const reviewsNewCount = element.querySelector('.junip-product-review-count');
	// 		const reviewsNewReviewBtn = element.querySelector('.junip-write-review-cta-container .junip-write-review-cta');

	// 		document.querySelector('.junip-btn.junip-btn-sm.junip-see-more').addEventListener('click', (e) => {
	// 			reviewsTitle.innerHTML = '';
	// 		})
	// 		reviewsNewCount.innerHTML = `(${reviewsNewCount.innerHTML})`;
	// 		reviewsNewContainer.prepend(reviewsTitle);
	// 		reviewsTitle.innerHTML = 'Reviews';

	// 		modifyReviewListItems(element);
	// 	});

	waitForElement('.quickbuy__form.has-dynamic-buttons')
		.then(el => {
			const secondLabel = document.querySelector('label[for="SingleOptionSelector-1"]');
			if (secondLabel) {
				const firstLabel = document.querySelector('label[for="SingleOptionSelector-0"]');
				const secondSelect = document.querySelector('#SingleOptionSelector-1');
				firstLabel.innerText = 'Choose your first flavour:';
				secondLabel.innerText = 'Choose your second flavour:';
				secondSelect.setAttribute('data-colour-swatch', 'true');
			}
		})

	new MutationObserver((mutations, observer) => {
		for (let mutation of mutations) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				const newItem = mutation.addedNodes[0];
				if (newItem.nodeType === Node.ELEMENT_NODE && newItem.classList.contains('junip-review-list-item-container')) {
					// modifyReviewListItems(newItem);
				}
			}
		}
	})
		.observe(document.documentElement, {
			childList: true,
			subtree: true
		});


});


document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.section-product-template ul.slick-dots')) {
		const dots = document.querySelectorAll('.section-product-template ul.slick-dots li');

		if (dots.length < 20) {
			dots[0].parentElement.style.width = 'fit-content';
		}
	}

	if (document.querySelector('.btn.btn-primary.btn--primary.button')) {
		document.querySelector('.btn.btn-primary.btn--primary.button').parentElement.style.border = 'none';
	}

	const productBenefitsSubList = document.querySelector('.product__benefits  ol');
	const productBenefitsListItems = document.querySelectorAll('.product__benefits ul li');

	if (productBenefitsSubList && productBenefitsListItems && productBenefitsListItems.length > 0) {
		const productBenefitsLastListItem = productBenefitsListItems[productBenefitsListItems.length - 1];
		productBenefitsLastListItem.append(productBenefitsSubList);
	} else {
		console.log('Some of the elements are missing on the page.');
	}

	if (document.querySelectorAll(".accordion-button")) {
		let acc = document.querySelectorAll(".accordion-button");

		acc.forEach(function (el) {
			el.addEventListener("click", function () {
				this.classList.toggle("active");
				let panel = this.nextElementSibling;
				panel.classList.toggle("open");

				let symbol = this.querySelector(".plus-minus");
				symbol.classList.toggle("active");
			});
		});
	}


	if (document.querySelector('.product__ingredients-content')) {
		// сохраняем содержимое всех блоков с ингридиентами
		let ingredientsContent = {};
		let ingredients = document.querySelectorAll('.product__ingredients-content');
		ingredients.forEach(function (el) {
			ingredientsContent[el.getAttribute('data-value')] = el.innerHTML;
		});

// устанавливаем содержимое блока по умолчанию
		let defaultContent = document.querySelector('.product__ingredients-content');
		defaultContent.innerHTML = ingredientsContent[defaultContent.getAttribute('data-value')];

// сохраняем ссылку на элемент для заголовка
		let titleElement = document.querySelector('.product__ingredients-title');

// добавляем обработчик события по клику на каждую ссылку
		let links = document.querySelectorAll('.clickyboxes li a');
		links.forEach(function (link) {
			link.addEventListener('click', function () {
				let selectedValue = this.getAttribute('data-value'); // получаем значение data-value у нажатой ссылки
				defaultContent.innerHTML = ingredientsContent[selectedValue]; // заменяем содержимое блока
				titleElement.textContent = selectedValue; // заменяем текст заголовка
			});
		});
	}

	// установить общее количество продуктов
	if (document.getElementById('total-products')) {
		document.getElementById('total-products').textContent = $('[data-all]').val();
	}


	$(document).on('click', '.js-load-more', function () {
		var $this = $(this),
			totalPages = parseInt($('[data-all-pages]').val()),
			currentPage = parseInt($('[data-this-page]').val()),
			datacollurl = $('[data-coll-url]').val();

		$this.attr('disabled', true);
		$this.find('[load-more-text]').addClass('hide');
		$this.find('[loader]').removeClass('hide');

		var nextUrl = $('[data-next-link]').val();
		var current_page_new = currentPage + 1;
		var next_coll = currentPage + 2;

		$.ajax({
			url: nextUrl,
			type: 'GET',
			dataType: 'html',
			success: function (responseHTML) {
				$('[data-next-link]').val(datacollurl + "?page=" + next_coll);
				$('[data-this-page]').val(current_page_new);
				$('.collection-template__items').append($(responseHTML).find('.collection-template__items').html());

				// обновить количество показанных продуктов
				var shownProducts = document.querySelectorAll('.collection-template__items > .product-block.lara.js-contains-quickbuy').length;
				document.getElementById('shown-products').textContent = shownProducts;
			},
			complete: function () {
				if (current_page_new < totalPages) {
					$this.attr('disabled', false);
					$this.find('[load-more-text]').removeClass('hide');
					$this.find('[loader]').addClass('hide');
				}
				if (current_page_new >= totalPages) {
					$this.find('[load-more-text]').text('Products Finished').removeClass('hide');
					$this.find('[loader]').addClass('hide');
				}
			}
		});
	});


});



